module.exports = __webpack_public_path__ + "static/media/team-amanda.4e097cc5.jpg";